import { HeroBullet } from './HeroBullet';

interface WhatHappensNextProps {
    items: string[];
}
export const WhatHappensNext = ({ items }: WhatHappensNextProps) => (
    <div className='w-full max-w-400'>
        <p className={'font-sora-bold mb-4 lg:mb-6 text-lg'}>
            What happens next?
        </p>
        <div className='mb-6'>
            {items.map((item, index) => {
                return (
                    <HeroBullet number={index + 1} key={index}>
                        {item}
                    </HeroBullet>
                );
            })}
        </div>
    </div>
);
